import { httpsCallable } from 'firebase/functions';
import { RedactedAudioResponse, Transcript, PiiPolicy } from 'assemblyai';

import { functions } from '../../../firebase.js';

interface RedactCallAudioParams {
  mediaUrl: string;
  piiPolicies?: PiiPolicy[];
}

interface CheckRedactedAudioStatusParams {
  transcriptId: string;
}

const redactCallAudioFunction = httpsCallable<
  RedactCallAudioParams,
  Transcript
>(functions, 'redactAudio');

export const redactCallAudio = async (
  params: RedactCallAudioParams
): Promise<Transcript> => {
  const result = await redactCallAudioFunction(params);
  return result.data;
};

const checkRedactedCallAudioStatusFunction = httpsCallable<
  CheckRedactedAudioStatusParams,
  RedactedAudioResponse
>(functions, 'checkRedactedAudioStatus');

export const checkRedactedAudioStatus = async (
  params: CheckRedactedAudioStatusParams
): Promise<RedactedAudioResponse> => {
  const result = await checkRedactedCallAudioStatusFunction(params);
  return result.data;
};
